import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "./index.scss";
$(function () {
  /***  展开  ***/
  function setupShowMore() {
    $(document).on("click", ".filter-container__item-more", function () {
      var $this = $(this);
      var $contentContainers = $this.siblings(".filter-container__item-content");
      var $moretext = $this.find(".filter-container__item-more-text");
      var isShowAll = $contentContainers.hasClass("filter-container__item-content-min");

      if (isShowAll) {
        $contentContainers.removeClass("filter-container__item-content-min");
      } else {
        $contentContainers.addClass("filter-container__item-content-min");
      }

      if ($moretext.length > 0) {
        $moretext.text(isShowAll ? "收起" : "更多");
      }

      $this.find(".js-hover-icon").css({
        transition: "transform .3s ease-in",
        transform: "rotate(" + (isShowAll ? 180 : 0) + "deg)"
      });
    });
  }

  setupShowMore();
  /**  城市区域框展开-----平铺 **/

  function setupShowSecond() {
    $(document).on("mouseenter", ".js-hover-icon-secondcontain", function () {
      var $this = $(this);
      $this.siblings("li").find(".js-hover-icon").css({
        transition: "transform .3s ease-in",
        transform: "rotate(0deg)"
      });
      /** 二级地区之类的小弹出框 **/

      var $secondContent = $this.find(".filter-container__item-childinfo");

      if ($secondContent.length > 0) {
        $this.siblings("li").find(".filter-container__item-childinfo").hide();
        $secondContent.show();
      }
      /***  产品二级分类  ***/


      var $boxContent = $this.find(".filter-container__item-boxchild");

      if ($boxContent.length > 0) {
        $this.addClass("currSelected");
        $this.siblings("li").removeClass("currSelected");
        $this.siblings("li").find(".filter-container__item-boxchild").hide();
        $boxContent.show();
      }

      $this.find(".js-hover-icon").css({
        transition: "transform .3s ease-in",
        transform: "rotate(180deg)"
      });
    });
  }

  setupShowSecond();
  /** 地区点击两层弹出 **/

  function setupRegionMouseEnterDialog() {
    $(document).on("mouseenter", ".filter-container__item-region,.filter-container__item-region-city", function () {
      var $this = $(this);
      $this.children(".js-hover-icon").css({
        transition: "transform .3s ease-in",
        transform: "rotate(180deg)"
      });
      var $ulContent = $this.children("ul");

      if ($ulContent.length > 0) {
        $ulContent.show(); //省份情况

        $this.siblings("li").find("ul").hide();
        $this.siblings("li").children(".js-hover-icon").css({
          transition: "transform .3s ease-in",
          transform: "rotate(0deg)"
        });
      }
    });
  }

  setupRegionMouseEnterDialog();

  function setupRegionMouseLeaveDialog() {
    $(document).on("mouseleave", ".filter-container__item-region-province,.filter-container__item-region-city", function () {
      var $this = $(this);
      $this.parent("li").children(".js-hover-icon").css({
        transition: "transform .3s ease-in",
        transform: "rotate(0deg)"
      });
      var $subCity = $this.find(".filter-container__item-region-city");

      if ($subCity.length > 0) {
        $subCity.hide();
      }

      $this.hide();
    });
  }

  setupRegionMouseLeaveDialog();
  /** 鼠标移除层，恢复原始状态 **/

  function setupLeaveSecondContainer() {
    $(document).on("mouseleave", ".filter-container__item-childinfo", function () {
      var $this = $(this);
      $this.parent(".js-hover-icon-secondcontain").find(".js-hover-icon").css({
        transition: "transform .3s ease-in",
        transform: "rotate(0deg)"
      });
      $this.hide();
    });
    $(document).on("mouseleave", ".js-hover-icon-secondcontain", function () {
      var $this = $(this);
      $this.find(".js-hover-icon").css({
        transition: "transform .3s ease-in",
        transform: "rotate(0deg)"
      });
      $this.removeClass("currSelected");
      $this.find(".filter-container__item-boxchild").hide();
    });
  }

  setupLeaveSecondContainer();

  function setupCheckbox() {
    $(document).on("change", "#IsCompanyVerified,#IsVipCompany,#HasOnlyCompany", function () {
      var $this = $(this);
      location.href = $this.data("url");
    });
  }

  setupCheckbox();
});